"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WAttachmentModal = class WAttachmentModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    attachment;
    onAttachment(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("attachment");
    }
    object_id;
    onObject_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("object_id");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.attachment || { object_id: this.object_id, description: null };
    }
    uploadTitle;
    editTitle;
    file;
    ux;
    b_7789867021953041_validation;
    dataMembers = ['formId', 'item', 'uploadTitle', 'editTitle', 'file', 'ux', 'b_7789867021953041_validation'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                item: null,
                uploadTitle: this.$fn.pgettext("Attachments", "Upload file"),
                editTitle: this.$fn.pgettext("Attachments", "Edit description"),
                file: null,
                ux: null,
                b_7789867021953041_validation: ["required",
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.attachment ? this.editTitle : this.uploadTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3190_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_3196_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async act_1040167445267876_request_3194_getActionArgs($event) {
        return {
            operation: this.attachment ? 'update_attachment' : 'create_attachment',
            data: this.attachment ? this.item : { ...this.item, file: this.file },
            contentType: this.attachment ? 'application/json' : 'multipart/form-data',
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3198_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3190 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3190_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3189 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3190,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3189],
        });
        const act_2248226175642056_closeModal_3192 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_3191 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_3192,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3191],
        });
        const act_1040167445267876_closeModal_3196 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_3196_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3195 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_3196,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_3194 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_3194_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_3195],
        });
        const evh_1040167445267876_submit_3193 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_3194,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3193],
        });
        const act_1419464017721962_closeModal_3198 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3198_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3197 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3198,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3197],
        });
        return {
            act_7315092382398562_closeModal_3190,
            evh_7315092382398562_close_3189,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_3192,
            evh_2248226175642056_close_3191,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_3196,
            evh_1040167445267876_success_3195,
            act_1040167445267876_request_3194,
            evh_1040167445267876_submit_3193,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_3198,
            evh_1419464017721962_clickPreventStop_3197,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_3194,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], WAttachmentModal.prototype, "attachment", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('attachment'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WAttachmentModal.prototype, "onAttachment", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], WAttachmentModal.prototype, "object_id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('object_id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WAttachmentModal.prototype, "onObject_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WAttachmentModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WAttachmentModal.prototype, "onSize", null);
WAttachmentModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], WAttachmentModal);
exports.default = WAttachmentModal;
vue_property_decorator_1.Vue.component("WAttachmentModal", WAttachmentModal);
